module.exports = __webpack_public_path__ + "media/smw_power-up.01d1241b.ogg";